module.exports = __webpack_public_path__ + "img/m3.27be1810.png";